import { render } from "./PermissionSettings.vue?vue&type=template&id=3d00bc8a&scoped=true"
import script from "./PermissionSettings.vue?vue&type=script&lang=js"
export * from "./PermissionSettings.vue?vue&type=script&lang=js"

import "./PermissionSettings.vue?vue&type=style&index=0&id=3d00bc8a&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d00bc8a"]])

export default __exports__